<template>
    <a-card :title="title">
        <div class="content">
            <a-spin v-if="loading" tip="Loading..."/>
            <GmapMap
                    v-show="!loading"
                    style="margin: -24px; height:300px"
                    :zoom=mapParams.zoom
                    :center=mapParams.center
            >
                <Gmap-Marker
                        v-if="!loading && truck.currentLocation"
                        :position="{
                                        lat: Number(truck.currentLocation.data.lat),
                                        lng: Number(truck.currentLocation.data.lng),
                                    }"
                        :icon="{
                                        path: (truck.stopped || (truck.currentLocation && !truck.currentLocation.data.status)) ? 0 : 2,
                                        scale: (truck.stopped || (truck.currentLocation && !truck.currentLocation.data.status)) ? 5 : 3,
                                        rotation: Number(truck.currentLocation.data.course_over_ground)
                                    }"
                        @click="infoWindow = truck">
                </Gmap-Marker>
                <Gmap-Info-Window
                        v-if="infoWindow !== null"
                        :opened="infoWindow !== null"
                        :position="{ lat: infoWindow.currentLocation.data.lat, lng: infoWindow.currentLocation.data.lng }"
                        @closeclick="infoWindow = null">
                    {{ infoWindow.description }}
                    <br>{{ infoWindow.currentLocation.data.speed }}km/h, {{ moment(infoWindow.currentLocation.data.time).fromNow() }} ({{ moment(infoWindow.currentLocation.data.time).format('h:mm:ss a, ddd Do MMM \'YY') }})
                    <br><strong>Ignition:</strong> {{ infoWindow.currentLocation.data.status ? 'On' : 'Off' }}
                    <br><b>Location: </b>{{ infoWindow.currentLocation.data.location }}
                </Gmap-Info-Window>
            </GmapMap>
        </div>
   </a-card>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            truckId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
                truck: {},
                infoWindow: null,
            }
        },
        methods: {
            moment,
            loadTruck(truckId) {
                this.loading = true;
                api.get('/carrier/gps/trucks/' + truckId, {
                    params: {
                        include: 'currentLocation'
                    }
                }).then(response => {
                    this.truck = response.data.data;
                }).catch(error => {
                    console.log(error)
                }).then(() => {
                    this.loading = false;
                });
            },
        },
        mounted() {
            console.log('Truck ' + this.truckId + ' is loading...');
            this.loadTruck(this.truckId);
        },
        computed: {
            title: function () {
                if (!this.loading && this.truck.currentLocation) {
                    return this.truck.plate;
                }
                return 'Truck';
            },
            mapParams: function () {
                if (!this.loading && this.truck.currentLocation) {
                    return {
                        center: {
                            lat: Number(this.truck.currentLocation.data.lat),
                            lng: Number(this.truck.currentLocation.data.lng),
                        },
                        zoom: 12,
                    }
                }
                return {
                    center: {
                        lat: -41.543,
                        lng: 174.0277
                    },
                    zoom: 6,
                }
            }
        }
    }
</script>

<style scoped>
    .content {
        text-align: center;
    }
</style>
